export default "__VITE_ASSET__8882a8f5__"